// Atalhos "+10d / +30d…" da parcela (Rafael, 06/10): a data é a do calendário LOCAL. Antes usava
// toISOString() (UTC) e, depois das 21h no horário de Brasília, gravava um dia a mais.
export function dataLocalMaisDias(dias, agora = new Date()) {
    const d = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + dias);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
}
